<div class="container-fluid">
  <div class="row">
    <div class="price-group-header">
      {{editing ? ( 'bikeshop.rentals.pricing.edit' | translate ) : ( 'bikeshop.rentals.pricing.add' | translate )}}
    </div>
  </div>
</div>

<div *ngIf="loading" style="margin-top: 64px;display: flex;justify-content: center;">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
  </p-progressSpinner>
</div>

<div class="container-fluid" style="padding-bottom: 64px;">
  <div>
    <div class="info-container content">
      <div class="row margin-top-8">
        <div class="col-md-4 label"
          [ngClass]="{'red bold': priceGroup.name === undefined || priceGroup.name.length === 0}">
          {{ 'bikeshop.rentals.pricing.price_group_name' | translate }}:
        </div>
        <div class="col-md-8 value">
          <input type="text" pInputText [(ngModel)]="priceGroup.name" [disabled]="savingPriceGroup" />
        </div>
      </div>

      <!-- <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{ 'bikeshop.rentals.pricing.price_group_description' | translate }}:
        </div>
        <div class="col-md-8 value">
          <textarea pInputTextarea [(ngModel)]="priceGroup.description" [autoResize]="true"></textarea>
        </div>
      </div>
    </div> -->

    <div class="row margin-top-16">
      <div class="col-md-12 label">
        <div class="link-sku-message">{{ 'bikeshop.rentals.pricing.link_sku_message' | translate }}</div>
      </div>
    </div>

    <div class="info-container content" *ngFor="let allocatedTimePrice of priceGroup.allocatedTimePrice">
      <div class="label header">{{ allocatedTimePrice.unit }} {{ allocatedTimePrice.unitType}}{{allocatedTimePrice.unit > 1 ? 's' : '' }}</div>
        <div class="row">
          <div class="col-md-4 label">
            {{ 'bikeshop.rentals.pricing.link_sku_to_time_unit' | translate }}:</div>
          <div class="col-md-4">
            <p-autoComplete [(ngModel)]="allocatedTimePrice.newSku" field="SKU" [suggestions]="searchResult" placeholder="{{
                  'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
                    | translate
                }}" (completeMethod)="searchProducts($event)" (onSelect)="linkSku(allocatedTimePrice.newSku, allocatedTimePrice)" [disabled]="savingPriceGroup">
              <ng-template let-product pTemplate="item">
                <div>
                  <span>{{ product.SKU }} - {{ product.Name }}</span>
                </div>
              </ng-template>
            </p-autoComplete>
          </div>
          <div class="col-md-2 label">
            {{ 'bikeshop.rentals.products.quantity' | translate }}:</div>
          <div class="col-md-2">
            <input type="number" pInputText [(ngModel)]="allocatedTimePrice.quantity" [disabled]="savingPriceGroup" />
          </div>
        </div>
        <div class="row margin-top-8" *ngIf="allocatedTimePrice.internalProductID">
          <div class="col-md-4"></div>
          <div class="col-md-7 linked-sku-message"><div>{{allocatedTimePrice.sku}}</div><div>{{allocatedTimePrice.name}}</div><div *ngIf="allocatedTimePrice.rate"><span>{{allocatedTimePrice.rate | currency : allocatedTimePrice.currencySymbol}}</span></div></div>
          <div class="col-md-1 flex"><span class="fa fa-trash" (click)="removeSKU(allocatedTimePrice)"></span></div>
        </div>
      </div>

      <div class="margin-top-16 button-container">
        <div class="row margin-bottom-16" *ngIf="!isValid()">
          <div class="col-md-12">
            <div class="red bold" style="font-size: 16px; text-align: right;">{{
              'bikeshop.rentals.products.validation_message' | translate }}</div>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <div style="display: flex;">
            <div *ngIf="editing" style="margin-right: 20px;">
              <button pButton *ngIf="!removingPriceGroup"
                label="{{'bikeshop.rentals.pricing.remove_price_group' | translate}}"
                class="p-button-raised alternate" (click)="removePriceGroup()" [disabled]="savingPriceGroup"
                style="width: 200px;"></button>
              <div *ngIf="removingPriceGroup">
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
                </p-progressSpinner>
              </div>
            </div>
          </div>
          <button *ngIf="!savingPriceGroup" pButton (click)="savePriceGroup()" class="p-button-raised"
            label="{{'bikeshop.general.save' | translate}}" [disabled]="!isValid() || removingPriceGroup"
            style="width: 200px;"></button>
          <div *ngIf="savingPriceGroup">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s"></p-progressSpinner>
          </div>
        </div>
      </div>

    </div>
  </div>


  <p-confirmDialog key="add_edit_price_group"></p-confirmDialog>
